import { getDeviceId as getAmplitudeDeviceId } from 'state/amplitude/amplitude-package';

// Although this function does not need to be async, it's native counterpart does and we'd like to keep a consistent interface
export const getDeviceId = async () => Promise.resolve(getAmplitudeDeviceId() || '');
